(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lykos-product-carousel"] && !Shopify.designMode) return;
  try {
    
  function lykosCarouselScroll(sectionId, direction) {
    const track = document.getElementById('lykos-pcarousel-track-' + sectionId);
    if (!track) return;
    const item = track.querySelector('.lykos-pcarousel__item');
    if (!item) return;
    const itemWidth = item.offsetWidth + 16;
    track.scrollBy({ left: direction * itemWidth * 4, behavior: 'smooth' });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
